import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControlType, FormGroupComponent } from '../../../../forms';
import { AbstractFilterEngineFormComponent } from '../abstract-filter-form.component';

@Component({
  selector: 'iot-platform-ui-filter-number-field',
  standalone: true,
  imports: [FormGroupComponent],
  template: `<iot-platform-ui-form-group data-cy="iot-platform-ui-filter-number-field" [fields]="fields()" [group]="form" />`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterNumberFieldComponent extends AbstractFilterEngineFormComponent<number> {
  getControlValue() {
    return this.searchTermControl?.getRawValue();
  }

  getValueDisplay() {
    const value = this.getControlValue();
    return value !== null && value !== undefined ? String(value) : '';
  }

  hasValidValue() {
    const value = this.getControlValue();
    return value !== null && value !== undefined && !Number.isNaN(value);
  }

  getSearchFields() {
    return [
      {
        ...this.searchTermField,
        type: FormControlType.NUMBER
      }
    ];
  }
}
